/**
 * DenLoadingSkeleton — animated shimmer placeholder shown while
 * DenDispatcher resolves which Den to render and lazy-loads its bundle.
 * Mirrors the visual mass of a typical Den layout (hero + alps grid +
 * tools row + dossier collapse) so the page doesn't jump on hydration.
 */
export function DenLoadingSkeleton() {
  const Bar = ({ h = 16, w = "100%" }: { h?: number; w?: string }) => (
    <div
      className="rounded-md bg-muted animate-pulse"
      style={{ height: h, width: w }}
    />
  );
  return (
    <div className="space-y-4 p-4" data-foxchat-id="den-loading-skeleton">
      <div className="flex items-center gap-4">
        <div className="h-16 w-16 rounded-full bg-muted animate-pulse" />
        <div className="flex-1 space-y-2">
          <Bar h={20} w="60%" />
          <Bar h={14} w="40%" />
        </div>
      </div>
      <Bar h={50} />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Bar h={120} />
        <Bar h={120} />
        <Bar h={120} />
        <Bar h={120} />
      </div>
      <Bar h={40} />
      <Bar h={200} />
    </div>
  );
}

export default DenLoadingSkeleton;
